import { motion } from "framer-motion";

const SLOTS = [1, 2, 3];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="border-t border-white/10 px-6 md:px-12 py-32 md:py-40"
    >
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="font-mono-accent text-xs sm:text-sm uppercase tracking-[0.3em] text-[#8B99AE] mb-16"
      >
        From the floor
      </motion.p>
      <div className="grid md:grid-cols-3 gap-12 md:gap-16">
        {SLOTS.map((slot) => (
          <motion.div
            key={slot}
            data-testid={`testimonial-${slot}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: (slot - 1) * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="border-l-2 border-[#4ADE80]/50 pl-6 min-h-[10rem] flex flex-col justify-between"
          >
            <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#8B99AE]/60">
              Story {String(slot).padStart(2, "0")}
            </span>
            <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#8B99AE]/60">
              Coming soon
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
